(function () {
  'use strict';

  /* Scroll progress bar */
  function initScrollProgress() {
    var bar = document.querySelector('.scroll-progress');
    if (!bar) return;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? window.scrollY / h : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)) + ')';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* Announcement dismiss */
  function initAnnouncement() {
    var bar = document.querySelector('[data-announcement]');
    var close = document.querySelector('[data-announcement-close]');
    if (!bar || !close) return;
    if (sessionStorage.getItem('neloura-announcement-dismissed') === '1') {
      bar.hidden = true;
      document.body.classList.remove('has-announcement');
      return;
    }
    document.body.classList.add('has-announcement');
    close.addEventListener('click', function () {
      bar.hidden = true;
      document.body.classList.remove('has-announcement');
      sessionStorage.setItem('neloura-announcement-dismissed', '1');
    });
  }

  /* Cart drawer */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-cart-open]');
    var closers = drawer.querySelectorAll('[data-cart-close]');

    function open() {
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    closers.forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* FAQ accordion */
  function initFaq() {
    var items = document.querySelectorAll('[data-faq-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-faq-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (i) {
          i.classList.remove('is-open');
          var b = i.querySelector('[data-faq-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
    if (items.length) {
      items[0].classList.add('is-open');
      var firstBtn = items[0].querySelector('[data-faq-toggle]');
      if (firstBtn) firstBtn.setAttribute('aria-expanded', 'true');
    }
  }

  /* Product gallery */
  function initGallery() {
    var roots = document.querySelectorAll('[data-product-gallery]');
    roots.forEach(function (root) {
      var thumbs = root.querySelectorAll('[data-gallery-thumb]');
      var images = root.querySelectorAll('[data-gallery-image]');
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) {
            t.classList.remove('is-active');
          });
          images.forEach(function (img) {
            img.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
          if (images[i]) images[i].classList.add('is-active');
        });
      });
    });
  }

  /* Newsletter success (customer form still submits to Shopify) */
  function initNewsletter() {
    var form = document.querySelector('[data-newsletter-form]');
    if (!form) return;
    if (window.location.search.indexOf('customer_posted=true') !== -1 ||
        window.location.search.indexOf('form_type=customer') !== -1) {
      var success = document.querySelector('[data-newsletter-success]');
      if (success) {
        form.hidden = true;
        success.hidden = false;
      }
    }
  }

  /* Scroll reveals (IntersectionObserver) — mirrors Hydrogen whileInView */
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function markReveal(el, variant) {
    if (!el || el.classList.contains('reveal') || el.classList.contains('reveal--scale') ||
        el.classList.contains('reveal--left') || el.classList.contains('reveal--right')) {
      return;
    }
    if (variant === 'scale') el.classList.add('reveal--scale');
    else if (variant === 'left') el.classList.add('reveal--left');
    else if (variant === 'right') el.classList.add('reveal--right');
    else el.classList.add('reveal');
  }

  function prepareReveals() {
    /* Section headers */
    document.querySelectorAll(
      '.section .section-eyebrow, .section .section-headline, .section .page-width > div:first-child'
    ).forEach(function (el) {
      if (el.closest('.hero')) return;
      markReveal(el);
    });

    /* Ritual */
    markReveal(document.querySelector('.ritual__image'), 'left');
    markReveal(document.querySelector('.ritual__body'), 'right');

    /* Purchase */
    document.querySelectorAll('.purchase__grid > *').forEach(function (el, i) {
      markReveal(el, i === 0 ? 'left' : 'right');
    });

    /* Commitment */
    markReveal(document.querySelector('.commitment__header'));
    markReveal(document.querySelector('.commitment__image'), 'scale');
    var commitmentBadges = document.querySelector('.commitment__badges');
    if (commitmentBadges) {
      commitmentBadges.classList.add('reveal-stagger');
      commitmentBadges.querySelectorAll('.commitment__badge').forEach(function (el) {
        markReveal(el);
      });
    }

    /* Story */
    markReveal(document.querySelector('.story__media'), 'left');
    markReveal(document.querySelector('.story__content'), 'right');

    /* Reviews */
    markReveal(document.querySelector('.reviews__header'));
    markReveal(document.querySelector('.reviews__carousel'));

    /* Journal */
    markReveal(document.querySelector('.journal__header'));
    markReveal(document.querySelector('.journal__featured'), 'left');
    markReveal(document.querySelector('.journal__side'), 'right');
    var journalMobile = document.querySelector('.journal__mobile');
    if (journalMobile) {
      journalMobile.classList.add('reveal-stagger');
      journalMobile.querySelectorAll('.journal__mobile-item').forEach(function (el) {
        markReveal(el);
      });
    }

    /* FAQ */
    markReveal(document.querySelector('#faq .page-width > div:first-child'));
    var faqList = document.querySelector('.faq-list');
    if (faqList) {
      faqList.classList.add('reveal-stagger');
      faqList.querySelectorAll('.faq-item').forEach(function (el) {
        markReveal(el);
      });
    }

    /* Newsletter */
    markReveal(document.querySelector('.newsletter-card'), 'scale');

    /* Explicit data-reveal hooks */
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      var v = el.getAttribute('data-reveal') || 'up';
      if (v === 'scale') markReveal(el, 'scale');
      else if (v === 'left') markReveal(el, 'left');
      else if (v === 'right') markReveal(el, 'right');
      else markReveal(el);
    });
  }

  function initReveals() {
    if (prefersReducedMotion()) {
      document.querySelectorAll('.reveal, .reveal--scale, .reveal--left, .reveal--right').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    prepareReveals();

    var nodes = document.querySelectorAll('.reveal, .reveal--scale, .reveal--left, .reveal--right');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    nodes.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Review carousel */
  function initReviewCarousels(scope) {
    var context = scope || document;
    var roots = [];
    if (context.matches && context.matches('[data-review-carousel]')) roots.push(context);
    context.querySelectorAll('[data-review-carousel]').forEach(function (root) {
      roots.push(root);
    });

    roots.forEach(function (root) {
      if (root.getAttribute('data-review-ready') === 'true') return;

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-review-card]'));
      var previous = root.querySelector('[data-review-prev]');
      var next = root.querySelector('[data-review-next]');
      var counter = root.querySelector('[data-review-counter]');
      var dragSurface = root.querySelector('[data-review-drag]');
      var current = 0;
      var pointerStart = null;

      if (!cards.length) return;
      root.setAttribute('data-review-ready', 'true');

      function formatNumber(value) {
        return value < 10 ? '0' + value : String(value);
      }

      function update() {
        cards.forEach(function (card, index) {
          var difference = (index - current + cards.length) % cards.length;
          var slot = 'hidden';
          if (difference === 0) slot = 'active';
          else if (difference === 1) slot = 'next';
          else if (difference === cards.length - 1) slot = 'previous';

          card.setAttribute('data-review-slot', slot);
          card.setAttribute('aria-hidden', slot === 'active' ? 'false' : 'true');
          if ('inert' in card) card.inert = slot !== 'active';
        });

        if (counter) {
          counter.textContent = formatNumber(current + 1) + ' / ' + formatNumber(cards.length);
        }
      }

      function move(direction) {
        current = (current + direction + cards.length) % cards.length;
        update();
      }

      if (previous) {
        previous.addEventListener('click', function () {
          move(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          move(1);
        });
      }
      if (dragSurface && cards.length > 1) {
        dragSurface.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            move(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            move(1);
          }
        });
        dragSurface.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          pointerStart = { id: event.pointerId, x: event.clientX };
          if (dragSurface.setPointerCapture) dragSurface.setPointerCapture(event.pointerId);
        });
        dragSurface.addEventListener('pointerup', function (event) {
          if (!pointerStart || event.pointerId !== pointerStart.id) return;
          var distance = event.clientX - pointerStart.x;
          pointerStart = null;
          if (Math.abs(distance) >= 40) move(distance < 0 ? 1 : -1);
        });
        dragSurface.addEventListener('pointercancel', function () {
          pointerStart = null;
        });
      }

      update();
    });
  }

  /* Our story letter toggle */
  function initStory(context) {
    var roots = [];
    if (context && context.matches && context.matches('[data-story]')) roots.push(context);
    (context || document).querySelectorAll('[data-story]').forEach(function (root) {
      if (roots.indexOf(root) === -1) roots.push(root);
    });
    roots.forEach(function (root) {
      if (root.dataset.storyReady === '1') return;
      root.dataset.storyReady = '1';
      var btn = root.querySelector('[data-story-toggle]');
      var more = root.querySelector('[data-story-more]');
      if (!btn || !more) return;
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        more.hidden = isOpen;
        btn.textContent = isOpen ? btn.dataset.expandLabel : btn.dataset.collapseLabel;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollProgress();
    initAnnouncement();
    initCartDrawer();
    initFaq();
    initGallery();
    initNewsletter();
    initReviewCarousels();
    initStory();
    initReveals();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initReviewCarousels(event.target);
    initStory(event.target);
  });
})();
